import type { RouteObject } from "react-router";
import { Kennzahlen } from "./Kennzahlen";

/** Kennzahlen mit Buchungen (Agentur). Gruppe „Kalender und Kennzahlen“. */
export const kennzahlenAgenturRoutes: RouteObject[] = [
  { path: "kennzahlen", element: <Kennzahlen /> },
];
